import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/marketing/google-ads-ppc")({ beforeLoad: redirectTo("/marketing/paid-advertising") });
